import React from 'react';
import { Col, Row } from 'react-bootstrap';
import NPPanel from '../../NPPanel';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import ReportArrivalDateModal from './ReportArrivalDateModal';
import LogisticsDataTable from '../LogisticsDataTable';

class LogisticsData extends React.Component {
    constructor(props) {
        super(props);

        this.onSelectRow = this.onSelectRow.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.logisticsDataRefreshCounter=this.logisticsDataRefreshCounter.bind(this);

        this.state = {
            showModal: false,
            selectedRow: null,
            refreshCounter:0
        };
    }

    onSelectRow(row) {
        this.setState({
            showModal: true,
            selectedRow: row,
        });
    }

    hideModal(saved) {
        this.setState({
            showModal: false,
        });
    }

    logisticsDataRefreshCounter(){
        this.setState({refreshCounter:this.state.refreshCounter+1});
    }

    render() {
        const { apiToken } = this.props;
        const { showModal, selectedRow } = this.state;
        let logisticsInformationNode = <LogisticsDataTable  apiToken={apiToken} onSelectRow={this.onSelectRow} refreshCounter={this.state.refreshCounter} />;

        return (<NPPanel>
            <Row>
                <Col sm={12}>
                    {logisticsInformationNode}
                </Col>
            </Row>

            {hasGrant(Grants.TYPES.Dashboard_ReportArrivalDate) &&
                <ReportArrivalDateModal showModal={showModal}
                    hideModal={this.hideModal}
                    selectedRow={selectedRow}
                    apiToken={apiToken}
                    reloadData={this.logisticsDataRefreshCounter}
                />
            }
        </NPPanel>)
    }
}

export default LogisticsData;
